/**
 * Normalize travel mode for persisted builder nodes/checkpoints.
 * @param {string} value
 * @returns {'DRIVING'|'WALKING'}
 */
const normalizeTravelMode = (value) => {
  const normalized = (value || '').toString().toUpperCase();
  return normalized === 'WALK' || normalized === 'WALKING' ? 'WALKING' : 'DRIVING';
};

export default normalizeTravelMode;
